import { render, staticRenderFns } from "./DisclaimerAccordion.vue?vue&type=template&id=318d3858&scoped=true&"
import script from "./DisclaimerAccordion.vue?vue&type=script&lang=ts&"
export * from "./DisclaimerAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./DisclaimerAccordion.vue?vue&type=style&index=0&id=318d3858&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d3858",
  null
  
)

export default component.exports